


















































































import Vue from 'vue';
import UnternehmenItem from '@/components/Unternehmen/UnternehmenItem.vue'
import Pagination from '@/components/Base/Pagination.vue'

export default Vue.extend({
  name: 'UnternehmenList',
  data() {
    return {
      activePage: 1,
      itemsPerPage: 30,
      order: "alpha"
    }
  },
  components: {
    UnternehmenItem,
    Pagination
  },
  // created() {
  //
  // },
  methods: {
    setActivePage(value: number): void {
      this.activePage = value;
    },

  },
  computed: {
    loading: function(): boolean {
      return this.$store.state.loading > 0;
    },
    unternehmen: function(): Array<object> {
      return this.$store.state.unternehmen.slice((this.activePage-1) * this.itemsPerPage, this.activePage * this.itemsPerPage);
    },
    paged: function(): boolean{
      return this.$store.state.unternehmen.length > this.itemsPerPage;
    },
    pages: function(): number {
      return Math.ceil(this.$store.state.unternehmen.length / this.itemsPerPage);
    },
    countUnternehmen: function(): number {
      return this.$store.state.unternehmen.length;
    }
  }

});
